module.exports = __webpack_public_path__ + "static/media/12UNCTAD17.0f80f01e.jpg";